import React from 'react';
import { Card, List, Typography, Tag } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import type { Notification } from '../../types/dashboard';

const { Text } = Typography;

interface NotificationSectionProps {
  notifications: Notification[];
  onMarkAsRead?: (id: string) => void;
}

const NotificationSection: React.FC<NotificationSectionProps> = ({ notifications, onMarkAsRead }) => {
  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <Card title={<><BellOutlined /> リアルタイム通知 ({unreadCount}件未読)</>}>
      <List
        dataSource={notifications.slice(0, 5)}
        size="small"
        renderItem={(item) => (
          <List.Item
            style={{ 
              backgroundColor: item.read ? 'transparent' : '#f6ffed',
              padding: '8px 12px',
              borderRadius: 4,
              marginBottom: 4,
              cursor: 'pointer'
            }}
            onClick={() => onMarkAsRead?.(item.id)}
          >
            <List.Item.Meta
              title={
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Tag color={item.type === 'success' ? 'green' : item.type === 'warning' ? 'orange' : 'blue'}>
                    {item.type}
                  </Tag>
                  {!item.read && <div style={{ width: 8, height: 8, backgroundColor: '#52c41a', borderRadius: '50%' }} />}
                </div>
              }
              description={
                <div>
                  <div style={{ fontSize: '12px', marginBottom: 4 }}>{item.message}</div>
                  <div style={{ fontSize: '11px', color: '#999' }}>
                    {new Date(item.timestamp).toLocaleString()}
                  </div>
                </div>
              }
            />
          </List.Item>
        )}
        locale={{ emptyText: '通知がありません' }}
      />
      {notifications.length > 5 && (
        <div style={{ textAlign: 'center', marginTop: 8 }}>
          <Text type="secondary">他 {notifications.length - 5} 件</Text>
        </div>
      )}
    </Card>
  );
};

export default NotificationSection;